import { module as ModuleJS } from "modujs";
import { gsap } from "gsap";

export default class extends ModuleJS {
    constructor(m) {
        super(m);

        this.active = false;
        this.nav = this.$("nav")[0];
        this.buttons = this.$("button");
        this.menu = this.nav.querySelector("ul");

        // Get all the link elements within the menu.
        this.links = this.menu.querySelectorAll("a");

        // Get all the link elements with children within the menu.
        this.linksWithChildren = this.menu.querySelectorAll(
            ".menu-item-has-children > a, .page_item_has_children > a"
        );

        this.header = document.getElementById("header");
        this.fakeNavItems = this.header.querySelectorAll('[href="#"]');

        this.NAV_ACTIVE_CLASS = "is-nav-active";
    }

    init() {
        this.onButtonClick = this.onButtonClick.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);

        if (!this.menu.classList.contains("nav-menu")) {
            this.menu.classList.add("nav-menu");
        }

        this.bindEvents();
    }

    getHeaderScrolledClass() {
        return this.HEADER_SCROLLED_CLASS;
    }

    onButtonClick(e) {
        this.toggle();
    }

    toggle() {
        if (this.active) {
            this.hide();
        } else {
            this.show();
        }
    }

    show() {
        this.active = true;
        document.documentElement.classList.add(this.NAV_ACTIVE_CLASS);

        for (const button of this.buttons) {
            button.setAttribute("aria-expanded", "true");
        }
    }

    hide() {
        this.active = false;
        document.documentElement.classList.remove(this.NAV_ACTIVE_CLASS);

        for (const button of this.buttons) {
            button.setAttribute("aria-expanded", "false");
        }
    }

    onDocumentClick(event) {
        const isClickInside = this.nav.contains(event.target);

        if (!isClickInside) {
            this.hide();
        }
    }

    bindEvents(el) {
        // Toggle the .toggled class and the aria-expanded value each time the button is clicked.
        for (const button of this.buttons) {
            button.addEventListener("click", this.onButtonClick, true);
        }

        // Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
        document.addEventListener("click", this.onDocumentClick);

        // Toggle focus each time a menu link is focused or blurred.
        for (const link of this.links) {
            link.addEventListener("focus", this.toggleFocus, true);
            link.addEventListener("blur", this.toggleFocus, true);
        }

        // Toggle focus each time a menu link with children receive a touch event.
        for (const link of this.linksWithChildren) {
            link.addEventListener("touchstart", this.toggleFocus, false);
        }

        // Désactivation clics a[href="#"]
        this.fakeNavItems.forEach(function (navItem) {
            navItem.addEventListener("click", function (e) {
                e.preventDefault();
            });
        });
    }

    update(newContainer) {
        this.bindEvents(newContainer);
    }

    destroy(oldContainer) {
        // this.el.removeEventListener("click", this.onClick);
    }

    /**
     * Sets or removes .focus class on an element.
     */
    toggleFocus(event) {
        if (event.type === "focus" || event.type === "blur") {
            let self = this;
            // Move up through the ancestors of the current link until we hit .nav-menu.
            while (!self.classList.contains("nav-menu")) {
                // On li elements toggle the class .focus.
                if ("li" === self.tagName.toLowerCase()) {
                    self.classList.toggle("-focus");
                }
                self = self.parentNode;
            }
        }

        if (event.type === "touchstart") {
            const menuItem = this.parentNode;
            event.preventDefault();
            for (const link of menuItem.parentNode.children) {
                if (menuItem !== link) {
                    link.classList.remove("-focus");
                }
            }
            menuItem.classList.toggle("-focus");
        }
    }
}
